<div class="confirm-container">
  <div class="header">
    <div class="img-container text-center">
      <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" width="200">
    </div>
  </div>

  <!-- Success Scenario -->
  @if (status === 'success') {
    <div class="confirm-content">
      <div class="header">
        <h4>PAYMENT SUCCESSFUL</h4>
      </div>
      <p>
        Your token pack has been successfully purchased and added to your account!
        You can view your new balance in the Tokens / Credits menu.
      </p>
    </div>
  }

  <!-- Cancelled Scenario -->
  @if (status === 'canceled' || status === 'cancelled') {
    <div class="confirm-content">
      <div class="header">
        <h4 class="text-danger">PAYMENT CANCELLED</h4>
      </div>
      <p>
        Your payment was cancelled.
        You can try purchasing a token pack again at any time.
      </p>
    </div>
  }

  <!-- Char Flow Success Scenario -->
  @if (status === 'char_success') {
    <div class="confirm-content">
      <div class="header">
        <h4>PAYMENT SUCCESSFUL</h4>
      </div>
      <p>
        Your tokens have been successfully purchased and added to your account!
        <br><br>
        You may now safely close this tab and return to your previous tab to continue generating. Your token balance will automatically refresh.
      </p>
    </div>
  }

  <!-- Char Flow Cancelled Scenario -->
  @if (status === 'char_canceled' || status === 'char_cancelled') {
    <div class="confirm-content">
      <div class="header">
        <h4 class="text-danger">PAYMENT CANCELLED</h4>
      </div>
      <p>
        Your payment was cancelled and no charges were made.
        <br><br>
        You may safely close this tab and return to your previous tab.
      </p>
    </div>
  }

  <div class="btn-sec">
    <button class="btn btn-green" (click)="close()">OK</button>
  </div>
</div>
